import React from "react";
import Delete from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';

const DeleteButton = props => {
  const onClick = event => {
    event.stopPropagation();
    props.onClick()
  };
  return (
    <IconButton aria-label="delete-item" onClick={onClick}>
      <Delete fontSize="small"/>
    </IconButton>
  );
};

export default DeleteButton;
